import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data.token) localStorage.setItem("errah_token", data.token);
        setUser(data.user);
        let dest = null;
        try { dest = JSON.parse(sessionStorage.getItem("errah_post_login") || "null"); } catch (_) {}
        sessionStorage.removeItem("errah_post_login");
        if (dest?.pathname && data.user.role !== "admin") {
          window.history.replaceState(null, "", dest.pathname);
          navigate(dest.pathname, { state: dest.state });
        } else {
          window.history.replaceState(null, "", "/my-errah");
          navigate("/my-errah", { state: { user: data.user } });
        }
      } catch (_) {
        navigate("/login");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="w-6 h-6 border-2 border-[#C9A45C] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
